module.exports = __webpack_public_path__ + "img/IRKUT.aecea136.png";